import React from "react";
import { Link } from "react-router-dom";

import NavBar from "../../components/NavBar/NavBar";
import Prefer from "../../components/Prefer/Prefer";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import Footer from "../../components/Footer/Footer";

import Bullet from "./SVG/bullet.svg";
import Interpretation1 from "../../images/interpretation1.png";
import Interpretation2 from "../../images/interpretation2.png";

import "./Interpretation.css";

const Interpretation = () => {
  return (
    <div className="interpretation">
      <NavBar interpretation />
      <div className="interpretation__hero container">
        <div>
          <h1 className="font-heading">See Our Numerous</h1>
          <h2 className="font-heading">Interpretation Services</h2>
          <p className="font-normal mt-20">
            Our Solutions are ever availbale to serve your need as we provide
            easy access to meet every of your need. We will never do lesser.
          </p>
          <Link
            className="d-block mt-20 py-20 px-40 text-center font-bold font-bigger"
            to="/quote"
          >
            Instant Quote
          </Link>
        </div>
      </div>
      <div className="interpretation__services container mt-40">
        <div className="interpretation__services__top mt-20 text-center">
          <h2 className="font-heading font-bolder">
            Interpretation Services We Offer
          </h2>
          <p className="font-heavy mt-20">
            Our Solutions are ever availbale to serve your need as we provide
            easy access to meet every of your need. We will never do lesser.
          </p>
        </div>
        <div className="interpretation__services__body d-flex align-center justify-center">
          <div className="interpretation__image__1">
            <img src={Interpretation1} alt="" />
          </div>
          <div className="interpretation__services__list">
            <h3 className="font-bigger font-bold my-20">
              We provide expertise on interpretations of all kinds.
            </h3>
            <div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Onsite Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Conference Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Simultaneous Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Legal Settings Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Sign Language Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Over the Phone Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Market Research Interpretation</span>
              </div>
            </div>
          </div>
        </div>
        <div className="interpretation__services__body d-flex align-center justify-center flex-row-reverse">
          <div className="interpretation__image__2">
            <img src={Interpretation2} alt="" />
          </div>
          <div className="interpretation__services__list">
            <h3 className="font-bigger font-bold my-20">
              You can find Everything you need. See More of Our Services
            </h3>
            <div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Consecutive Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Trade Shows Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Classrooms Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Tours Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Train Session Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Convention Interpretation</span>
              </div>
              <div className="my-20 d-flex align-center justify-start">
                <img className="mr-20" src={Bullet} alt="" />
                <span>Video Remote Interpretation</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="interpretation__banner container">
        <div>
          <h1 className="font-heavy font-normal">WE ARE READY TO HELP</h1>
          <h2 className="font-heading font-bold mb-40">
            This is not the end, we have more to offer to you.
          </h2>
          <Link to="/contact-us">Talk To Us</Link>
        </div>
      </div>
      <Prefer />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default Interpretation;
